function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawEnvironment = function UndrawEnvironment(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 886 654.301",
    style: style
  }, props), React.createElement("path", {
    d: "M377.697 443.685s117.663-14.12 158.845-36.476 347.105-32.945 347.105 36.476-351.812 100.013-351.812 100.013l-184.73-10.59z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M377.697 443.685s117.663-14.12 158.845-36.476 347.105-32.945 347.105 36.476-351.812 100.013-351.812 100.013l-184.73-10.59z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M411.82 430.742l-24.71 71.774L0 507.223V401.326s148.255-34.122 265.918 38.829c0 0 138.842-16.473 145.901-9.413z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M411.82 430.626l-24.71 71.775L0 507.107V401.211s148.255-34.123 265.918 38.828c0 0 138.842-16.472 145.901-9.413z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M854.404 400.738c0 4.01-8.993 6.987-9.877 10.856-.877 3.837 4.466 9.671 2.775 13.336a72.563 72.563 0 0 1-6.171 10.732c-2.215 3.172-9.057 2.709-11.862 5.683a94.319 94.319 0 0 1-8.713 7.576c-2.977 2.476-7.01 2.995-10.395 5.274-3.218 2.167-2.829 10.116-6.39 12.09-3.401 1.885-8.609.368-12.3 2.063-3.542 1.627-5.41 7.51-9.197 8.95-3.652 1.387-8.172.79-12.034 1.992-3.737 1.163-7.918.974-11.834 1.954-3.802.95-6.706 6.65-10.662 7.42-3.854.748-8.37-1.25-12.356-.682-3.891.554-8.417-4.372-12.42-3.999-3.919.365-7.611 2.645-11.624 2.83-3.935.18-7.825 1.913-11.84 1.913-4.013 0-8.154 3.765-12.088 3.585-4.013-.185-7.646-5.892-11.565-6.256-4.003-.373-8.779 5.588-12.67 5.034-3.986-.567-7.142-6.402-10.996-7.15-3.957-.77-9.067 3.401-12.87 2.45-3.917-.98-6.241-7.768-9.979-8.932-3.86-1.201-8.647.427-12.299-.961-3.787-1.44-8.401-1.208-11.944-2.835-3.69-1.695-6.34-5.706-9.742-7.592-3.56-1.973-5.202-6.867-8.42-9.034-3.386-2.28-8.543-1.989-11.52-4.465-3.143-2.614-9.032-2.75-11.684-5.562-2.806-2.975-3.94-7.969-6.155-11.14-2.333-3.341 2.245-10.403.616-13.934-1.69-3.664-8.755-5.152-9.632-8.989a56.435 56.435 0 0 1-1.384-12.207c0-4.01 6.043-7.075 6.927-10.943.877-3.837-3.57-9.348-1.88-13.012 1.63-3.531 1.42-8.96 3.754-12.3 2.215-3.171 7.743-4.415 10.548-7.389 2.652-2.812 7.4-3.596 10.543-6.21 2.976-2.475 2.597-9.941 5.982-12.22 3.219-2.167 7.713-3.156 11.273-5.13 3.402-1.885 8.217-1.567 11.907-3.262 3.542-1.627 9.09 1.579 12.878.14 3.652-1.388 6.614-4.42 10.475-5.623 3.737-1.163 5.493-10.035 9.409-11.014 3.802-.95 8.481.628 12.437-.14 3.854-.75 9.04 6.25 13.025 5.683 3.891-.554 6.802-9.898 10.805-10.27 3.919-.366 8.337 4.474 12.35 4.29 3.935-.181 7.886 2.655 11.9 2.655 4.013 0 8.012-3.892 11.946-3.711 4.013.184 7.55 5.327 11.47 5.692 4.003.372 8.918-7.45 12.81-6.896 3.985.567 7.064 6.614 10.918 7.362 3.957.769 8.912-2.985 12.716-2.034 3.916.98 6.272 7.407 10.01 8.57 3.86 1.202 6.24 5.736 9.892 7.124 3.787 1.44 10.823-5.294 14.366-3.667 3.69 1.695 6.878 4.628 10.28 6.514 3.56 1.973 9.22.98 12.439 3.148 3.385 2.28 4.217 8.398 7.194 10.874 3.143 2.614 8.328 3.4 10.98 6.213 2.805 2.974 3.195 8.304 5.41 11.476 2.332 3.34 2.26 7.968 3.888 11.5 1.69 3.663 6.202 6.434 7.078 10.27.884 3.868 3.502 8.3 3.502 12.31z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M430.645 474.277s132.96-68.244 218.853-42.358 205.91-18.826 220.03-3.53 34.121 180.024-135.313 189.437-314.16-28.24-314.16-28.24z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M399.334 467.01s52.49-3.322 50.137 15.504-4.706 164.727-18.826 168.257-125.899 3.53-171.787 3.53H0V428.727s183.554-10.928 275.33 34.96c0 0 110.342-1.592 124.004 3.322z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M645.24 114.18a27.041 27.041 0 0 0-23.31 16.297c-5.828 14.088 1.677 30.638 12.942 40.911s25.737 16.146 38.886 23.865c17.66 10.368 33.53 24.76 42.366 43.234s9.777 41.358-.61 59.008c-9.641 16.381-27.171 26.185-43.89 35.227",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M692.304 28.285a27.041 27.041 0 0 0-23.308 16.298c-5.829 14.089 1.676 30.638 12.941 40.912s25.737 16.146 38.886 23.864c17.66 10.368 33.53 24.76 42.367 43.234s9.776 41.359-.611 59.008c-9.641 16.381-27.171 26.186-43.89 35.228",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M847.05 48.04a27.041 27.041 0 0 0-28.407-1.382c-13.234 7.572-17.43 25.252-14.812 40.272s10.467 28.523 16.138 42.676c7.618 19.009 11.356 40.104 7.034 60.121s-17.588 38.688-36.606 46.285c-17.652 7.052-37.515 4.072-56.271.987",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 710.683,
    cy: 211.889,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 707.153,
    cy: 209.536,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 771.867,
    cy: 200.123,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 768.337,
    cy: 197.77,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 781.28,
    cy: 251.895,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 777.75,
    cy: 249.541,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 775.397,
    cy: 122.466,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 771.867,
    cy: 120.113,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 704.799,
    cy: 114.229,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 701.27,
    cy: 111.876,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 736.568,
    cy: 84.814,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 733.039,
    cy: 82.46,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 805.989,
    cy: 90.697,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 802.46,
    cy: 88.344,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 857.761,
    cy: 129.526,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 854.231,
    cy: 127.172,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 675.384,
    cy: 61.281,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 671.854,
    cy: 58.928,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 693.033,
    cy: 16.569,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 689.503,
    cy: 14.216,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 856.584,
    cy: 49.515,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 853.054,
    cy: 47.162,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 596.55,
    cy: 157.765,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 593.02,
    cy: 155.411,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 694.21,
    cy: 150.705,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 690.68,
    cy: 148.352,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 822.462,
    cy: 161.294,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 818.932,
    cy: 158.941,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 754.218,
    cy: 166.001,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 750.688,
    cy: 163.648,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 758.924,
    cy: 48.338,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 755.394,
    cy: 45.985,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 637.732,
    cy: 121.289,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 634.202,
    cy: 118.936,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 654.205,
    cy: 174.237,
    rx: 28.239,
    ry: 13.716,
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 650.675,
    cy: 171.884,
    rx: 28.239,
    ry: 13.716,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), React.createElement("g", {
    opacity: 0.3
  }, React.createElement("ellipse", {
    cx: 806.269,
    cy: 387.365,
    rx: 14.794,
    ry: 6.407,
    transform: "rotate(-60.799 623.285 459.867)",
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 804.407,
    cy: 388.443,
    rx: 14.794,
    ry: 6.407,
    transform: "rotate(-60.799 621.423 460.945)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), React.createElement("g", {
    opacity: 0.3
  }, React.createElement("ellipse", {
    cx: 948.032,
    cy: 414.816,
    rx: 6.407,
    ry: 14.794,
    transform: "rotate(-48.172 732.406 529.12)",
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 947.387,
    cy: 412.764,
    rx: 6.407,
    ry: 14.794,
    transform: "rotate(-48.172 731.76 527.067)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), React.createElement("g", {
    opacity: 0.3
  }, React.createElement("ellipse", {
    cx: 816.25,
    cy: 340.689,
    rx: 6.407,
    ry: 14.794,
    transform: "rotate(-48.172 600.623 454.992)",
    fill: "#57b894"
  }), React.createElement("ellipse", {
    cx: 815.605,
    cy: 338.636,
    rx: 6.407,
    ry: 14.794,
    transform: "rotate(-48.172 599.978 452.94)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })));
};
UndrawEnvironment.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawEnvironment;